import React from 'react';
import pathsManifest from '../../../pathsManifest';
import BrandSwitcher from './BrandSwitcher';

import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Link from '@zg-rentals/multibrand-ui/lib/Link';

import './style.scss';

const samplePages = [
  {
    title: 'Homepage',
    url: '/renter-hub',
  },
  {
    title: 'Inquiry feedback',
    url: '/renter-hub/response-feedback?allInquiryIds=4270143779656038686&allInquiryIdsHash=13a2c9826262e74dd5c7283c816829fb&startDate=2019-08-13&endDate=2019-08-13&utm_source=UserFeedback&utm_medium=email&utm_campaign=UserInquiryFeedback&ref=inquiryFeedback&nid=b01a14c3-bfac-11e9-ad63-0a603a2fde3c',
  },
  {
    title: 'Waitlist confirmation',
    url: pathsManifest.waitlistConfirmationPage,
  },
  {
    title: 'Tour feedback',
    url: '/renter-hub/tour-feedback?allInquiryIds=2939002688196929607,6346423173074856237,4747318840438017546,8506632004456282685,6174547630446021644,4671807756652110288,6361441864844289460&allInquiryIdsHash=2b63449180fd2d80b6614db37958cb17&startDate=2019-08-10&endDate=2019-08-12&utm_source=tourFeedback&utm_medium=email&utm_campaign=tourFeedback&ref=tourFeedback&nid=59fd75e0-bfa6-11e9-ad63-0a603a2fde3c',
  },
  {
    title: 'Terms',
    url: '/renter-hub/terms/Rental-User-Terms',
  },

  {
    title: 'Get user api call',
    url: `${__DEV__ ? '/renter-hub/proxy' : ''}/renter-hub-api/api/v1/users/get?pageWithSensitiveInformation=false`,
  },
];

class DevPage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="inset-lg">
        <div className="DevPage-title stacked-md">
          <Text type="h1">renter-hub-web</Text>
        </div>
        <div className="stacked-md">
          <Text type="body">
            A node.js web service for serving /renter-hub pages for the HotPads, Zillow, and Trulia brands.
          </Text>
        </div>
        <div className="stacked-lg">
          <Link href={pathsManifest.base}>Go to homepage</Link>
        </div>
        <div className="stacked-lg">{__DEV__ && <BrandSwitcher />}</div>
        {samplePages.map(({ url, title }) => (
          <div className="stacked-md" key={url}>
            <Link href={url}>{title}</Link>
          </div>
        ))}
      </div>
    );
  }
}

export default DevPage;
